import type {SalesPerson, UnmappedSalesPerson} from "./type";

export const mapSalesPerson: SalesPerson = (datum: UnmappedSalesPerson) => {
    if (!datum) return
    return {
        id: datum.id,
        name: datum.LoginName
    }
}
